<template>

  <section class="relative overflow-hidden text-white md:bg-transparent bg-[#1C1C1C]">
    <!-- Lime green accent shape -->

    <div class="absolute top-0 left-0 hidden w-full h-full md:block">
      <nuxt-img class="object-cover w-full h-full mx-auto" src="/assets/images/bg-apps.jpg" width="1920" height="976" format="webp"
        loading="lazy" sizes="xs:187px sm:187px md:187px lg:187px xl:187px " />

    </div>

    <div class="relative grid max-w-5xl grid-cols-12 px-4 py-10 mx-auto gap-y-8 gap-x-6 xl:gap-x-12 lg:py-20">

      <div class="col-span-12 mx-auto lg:col-span-7 lg:px-0">
        <div class="grid items-center gap-12">
          <div class="space-y-8">
            <div class="space-y-4">
              <div class="text-2xl font-bold text-center md:max-w-lg md:text-left md:text-3xl xl:text-32 font-ww-bold">
                Bonus: Don't Break The Chain,
                Habit Forming App
              </div>

              <!-- Download buttons -->
              <div class="flex gap-4 md:!mt-12 mt-8 flex-row md:justify-start justify-center">
                <button
                  class="flex items-center justify-start w-40 px-3 py-3 font-medium text-black transition-colors bg-white rounded-lg sm:px-6 sm:w-52 gap-x-3 hover:bg-gray-100">
                  <div>
                    <svg class="sm:w-9 w-7" width="34" height="41" viewBox="0 0 34 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M19.2385 9.70169C18.6475 9.87701 17.8122 10.0124 16.744 10.1084C16.7921 7.72594 17.4133 5.67094 18.6171 3.94625C19.7987 2.23268 21.7948 1.04868 24.6088 0.394531C24.6263 0.440333 24.6489 0.532031 24.6705 0.659364C24.6924 0.786696 24.7141 0.874024 24.7318 0.922106C24.7318 0.985392 24.7361 1.06626 24.7448 1.16223C24.7493 1.25906 24.7536 1.33765 24.7536 1.40378C24.7536 2.37892 24.5214 3.46467 24.058 4.66388C23.5807 5.86308 22.8363 6.96622 21.8298 7.97338C20.9674 8.83497 20.1007 9.41272 19.2385 9.70169ZM29.9834 26.5135C28.881 24.9329 28.3294 23.1471 28.3294 21.1649C28.3294 19.3574 28.8462 17.7025 29.8875 16.2014C30.4477 15.3828 31.3582 14.4418 32.6227 13.37C31.7911 12.3455 30.96 11.5493 30.1283 10.9715C28.6226 9.93383 26.9199 9.41281 25.0163 9.41281C23.8825 9.41281 22.4991 9.6842 20.8713 10.2271C19.3047 10.7743 18.1577 11.0429 17.4397 11.0429C16.8968 11.0429 15.7942 10.8049 14.1307 10.3239C12.4505 9.84365 11.0366 9.60562 9.88542 9.60562C7.13247 9.60562 4.8651 10.7561 3.07056 13.0585C1.26301 15.3915 0.361328 18.3853 0.361328 22.0266C0.361328 25.9009 1.53877 29.9184 3.8892 34.0938C6.27032 38.2344 8.67747 40.3047 11.1065 40.3047C11.9207 40.3047 12.9796 40.0332 14.2713 39.4905C15.5665 38.9615 16.7046 38.698 17.6804 38.698C18.7182 38.698 19.9261 38.9541 21.3 39.4641C22.7532 39.9765 23.8738 40.2319 24.6576 40.2319C26.706 40.2319 28.7581 38.6659 30.824 35.5318C32.1637 33.5335 33.1482 31.536 33.774 29.5377C32.347 29.1041 31.0868 28.0976 29.9834 26.5135Z"
                        fill="#1C1C1C" />
                    </svg>
                  </div>
                  <div class="text-left">
                    <span class="text-xs leading-none md:text-sm font-ww-bold">Download</span><br> <span
                      class="text-base leading-none md:text-lg font-ww-regular">for Mac</span>
                  </div>
                </button>
                <button
                  class="flex items-center justify-start w-40 px-3 py-3 font-medium text-black transition-colors bg-white rounded-lg sm:px-6 sm:w-52 gap-x-3 hover:bg-gray-100">
                  <div>
                    <svg class="sm:w-9 w-7" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.447266 30.4027L14.4964 32.4375V18.996H0.447266V30.4027ZM0.447266 17.0759H14.4964V3.63301L0.447266 5.66786V17.0759ZM16.4166 32.7159L35.2678 35.4462V18.996H16.4166V32.7159ZM16.4166 3.35395V17.0759H35.2678V0.625L16.4166 3.35395Z"
                        fill="#1C1C1C" />
                    </svg>
                  </div>
                  <div class="text-left">
                    <span class="text-xs leading-none md:text-sm font-ww-bold">Download</span> <br> <span
                      class="text-base leading-none md:text-lg font-ww-regular"> for Windows</span>
                  </div>
                </button>

              </div>
            </div>

            <div class="space-y-6 lg:text-lg text-base !leading-6 text-gray-300 font-ww-regular lg:pr-0 md:pr-32">
              Build unbreakable habits, one day at a time.
              <br><br>
              Transform your life through the power of consistency with Don't Break The Chain. This simple yet powerful
              habit tracker uses the proven psychology of visual progress to keep you motivated. Watch as your daily
              actions form an unbroken chain across your calendar – your growing streak becomes too precious to break.
              <br><br>
              Track multiple habits simultaneously, celebrate your longest streaks, and turn good intentions into
              lifelong routines. No complicated features, no learning curve – just open the app, mark your habit
              complete, and keep the chain growing.
              <br><br>
              Because the best habits aren't built on motivation alone – they're built on never breaking the chain.
            </div>
          </div>
        </div>
      </div>

      <div class="w-full col-span-12 lg:col-span-5">
        <nuxt-img class="mx-auto lg:absolute" src="/assets/images/image-phones.png" width="638" height="619" format="webp"
          loading="lazy" sizes="xs:187px sm:187px md:187px lg:187px xl:187px " />
      </div>
    </div>
  </section>

</template>